var map = {
	"./Anglerfish.png": 8522,
	"./GWENT.ttf": 1550,
	"./Saradomin_brew.png": 1759,
	"./backdrop.jpg": 9067,
	"./black_dragonhide.png": 9514,
	"./bond-diamond.png": 6114,
	"./bond-dragonstone.png": 7107,
	"./bond-emerald.png": 8856,
	"./bond-onyx.png": 2105,
	"./bond-prev.png": 9876,
	"./bond-ruby.png": 3931,
	"./bond-sapphire.png": 339,
	"./bond-zenyte.png": 2347,
	"./cart-disabled.png": 4028,
	"./cart.png": 258,
	"./dragon_dart_tip.png": 4432,
	"./gamble-pack.png": 580,
	"./investor.png": 6073,
	"./limitted.png": 1433,
	"./logo.png": 6715,
	"./magic_logs.png": 5623,
	"./magic_potion.png": 9566,
	"./magic_seed.png": 4126,
	"./mahogany_plank.png": 7962,
	"./mystery-box.png": 5757,
	"./pulsar.otf": 8319,
	"./pvm-booster.png": 5059,
	"./pvm-mage.png": 610,
	"./pvm-master.png": 9025,
	"./pvm-ranger.png": 2266,
	"./pvm-warrior.png": 512,
	"./ranarr_weed.png": 4944,
	"./rankboost.png": 9635,
	"./raw_shark.png": 1070,
	"./runite_ore.png": 8309,
	"./skiller-industrial.png": 837,
	"./skiller-master.png": 8329,
	"./skiller-nature.png": 3374,
	"./super_combat.png": 9761,
	"./super_ranging.png": 9412,
	"./super_restore.png": 6339,
	"./test1.png": 901,
	"./test2.png": 7734,
	"./vip.png": 5970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8971;